<template>
  <div id="toolBox">
    <el-tooltip
      class="item"
      v-if="tools.indexOf('distance') !== -1"
      popper-class="toolbox"
      :content="'测距'"
      placement="right"
    >
      <div class="tool-right" id="distance" title="测距" @click="toolClick('distance')"></div>
    </el-tooltip>
    <el-tooltip
      class="item"
      v-if="tools.indexOf('area') !== -1"
      popper-class="toolbox"
      :content="'测面'"
      placement="right"
    >
      <div class="tool-right" id="area" @click="toolClick('area')"></div>
    </el-tooltip>
    <el-tooltip
      class="item"
      v-if="tools.indexOf('angle') !== -1"
      popper-class="toolbox"
      :content="'测角'"
      title="测面"
      placement="right"
    >
      <div class="tool-right" id="angle" @click="toolClick('angle')"></div>
    </el-tooltip>
    <el-tooltip
      class="item"
      v-if="tools.indexOf('markPoint') !== -1"
      popper-class="toolbox"
      :content="'标点'"
      title="测面"
      placement="right"
    >
      <div class="tool-right" id="pointMarker" @click="toolClick('markPoint')"></div>
    </el-tooltip>
    <el-tooltip
      class="item"
      v-if="tools.indexOf('markLine') !== -1"
      popper-class="toolbox"
      :content="'标线'"
      placement="right"
    >
      <div class="tool-right" id="lineMarker" @click="toolClick('markLine')"></div>
    </el-tooltip>
    <el-tooltip
      class="item"
      v-if="tools.indexOf('markArea') !== -1"
      popper-class="toolbox"
      :content="'标面'"
      placement="right"
    >
      <div class="tool-right" id="areaMarker" @click="toolClick('markArea')"></div>
    </el-tooltip>
    <el-tooltip
      class="item"
      v-if="tools.indexOf('clear') !== -1"
      popper-class="toolbox"
      :content="'清空'"
      placement="right"
    >
      <div class="tool-right" id="clearMarker" @click="toolClick('clear')"></div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'map-tool-elem',
  props: {
    tools: {
      type: Array,
      default: () => ['distance', 'area', 'angle', 'markPoint', 'markLine', 'markArea', 'clear']
    }
  },
  data() {
    return {
      toolType: null,
      dotTimeStr: '',
      markerObjDot: {},
      dotIcon: null,
      map: null
    }
  },
  methods: {
    toolClick(info) {
      this.$emit('maptoolClick', info)
    }
  }
}
</script>
<style lang="scss" scoped>
#toolBox {
  position: fixed;
  top: 200px;
  right: 24px;
  z-index: 999;
  background: url('../../assets/image/maptool/tool_bg.png') no-repeat;
  background-size: 100% 100%;
  width: 56px;
  max-height: 479px;
  text-align: center;
}
.tool-right {
  width: 24px;
  height: 24px;
  margin: 40px auto;
  cursor: pointer;
}
#distance {
  background: url('../../assets/image/maptool/tool_icon_measure-range_default.png') no-repeat;
  background-size: 100% 100%;
  &:hover {
    background: url('../../assets/image/maptool/tool_icon_measure-range_selected.png') no-repeat;
    background-size: 100% 100%;
  }
}
#area {
  background: url('../../assets/image/maptool/tool_icon_measure-surface_default.png') no-repeat;
  background-size: 100% 100%;
  &:hover {
    background: url('../../assets/image/maptool/tool_icon_measure-surface_selected.png') no-repeat;
    background-size: 100% 100%;
  }
}
#angle {
  background: url('../../assets/image/maptool/tool_icon_angle.png') no-repeat;
  background-size: 100% 100%;
  &:hover {
    background: url('../../assets/image/maptool/tool_icon_angle_selected.png') no-repeat;
    background-size: 100% 100%;
  }
}
#pointMarker {
  background: url('../../assets/image/maptool/tool_icon_gauge-point_default.png') no-repeat;
  background-size: 100% 100%;
  &:hover {
    background: url('../../assets/image/maptool/tool_icon_gauge-point_selected.png') no-repeat;
    background-size: 100% 100%;
  }
}
#lineMarker {
  background: url('../../assets/image/maptool/tool_icon_gauge-line_default.png') no-repeat;
  background-size: 100% 100%;
  &:hover {
    background: url('../../assets/image/maptool/tool_icon_gauge-line_selected.png') no-repeat;
    background-size: 100% 100%;
  }
}
#areaMarker {
  background: url('../../assets/image/maptool/tool_icon_gauge-surface_default.png') no-repeat;
  background-size: 100% 100%;
  &:hover {
    background: url('../../assets/image/maptool/tool_icon_gauge-surface_selected.png') no-repeat;
    background-size: 100% 100%;
  }
}
#clearMarker {
  background: url('../../assets/image/maptool/tool_icon_delete_default.png') no-repeat;
  background-size: 100% 100%;
  &:hover {
    background: url('../../assets/image/maptool/tool_icon_delete_selected.png') no-repeat;
    background-size: 100% 100%;
  }
}
</style>
